/* FalcX vehicle state (r5, r2 2026-10-13 "browsing is not saving").
   Two stored vehicles, same shape {"series":"ba-bf","body":"ute"}:
   - SAVED: localStorage falcx-my-vehicle-v1. Written ONLY by an explicit save ("Make this my Falcon", [data-vehicle-keep]
     / [data-vehicle-save], FalcxVehicle.save / saveActive) and removed by "Forget" / "Clear vehicle" (clear()).
   - BROWSE: sessionStorage falcx-browse-vehicle-v1. Written by every browsing choice: a body style button, the Series
     dropdown picked by hand, the hero's car and series buttons, "Show parts for …", the dialog's Done, a Falcon hub
     page (a Shop by car chip) and an address that names a series (?series=&body=, or a #series= fragment, e.g. a menu link). Lasts this visit
     (this tab). Cleared by Forget, and by a save (the saved vehicle then is the one on show).
   Effective vehicle = browse, else saved, else none. A link or page that names a vehicle shows it on that page.
   An explicit body= in the address always wins (sedan included). A series-only address or a hub page opens on the body
   style of the browse vehicle for that series, else of the saved one, else the sedan. The menu links' body=sedan is
   dropped on the click by falcx-menu.js (r2 follow-up), so a menu card keeps the browsed/saved body style.
   getActive() is what listings lead with: the vehicle on show where the page or link names one, else the effective one.
   isMine(v) is true only for the saved vehicle ("your …", green tick).
   Events on document, all with detail {saved, browse, browsing, active, mine}: falcx:vehicle-change (saved vehicle or
   first paint), falcx:browsing-change (vehicle on show), and falcx:vehicle after every one of those (one event to
   listen to; detail.reason names which).
   r9 (listing): a link may also name the vehicle in its fragment, /collections/ea-el-falcon#series=ef-el(&body=ute), so
   the crawlable href stays the bare hub. ?series= in the query wins over the fragment; old ?series= links work as before.
   A plain anchor (#falcx-finder, #gen-ba-bf) is not read as a vehicle. */
(function () {
  'use strict';
  if (window.FalcxVehicle) { window.FalcxVehicle.init(); return; }
  var data = document.querySelector('[data-falcx-vehicle-data]');
  if (!data) return;
  var vehicles;
  try { vehicles = JSON.parse(data.textContent); } catch (e) { return; }
  function normalizeSeries(value) { return value === 'ea-el' ? 'ea-ed' : value === 'fg-fgx' ? 'fg' : value; }
  var storageKey = 'falcx-my-vehicle-v1';
  var browseKey = 'falcx-browse-vehicle-v1';
  function find(value) {
    if (!value) return null;
    return vehicles.find(function (v) { return typeof value === 'string' ? v.key === value : v.series === normalizeSeries(value.series) && v.body === value.body; }) || null;
  }
  /* A series/body pair that the vehicle data does not list (e.g. an FG wagon from an old link or saved vehicle)
     falls back to that series' sedan. Only a series the data does not know at all returns null. */
  function resolve(value) {
    if (!value) return null;
    if (typeof value === 'string') return find(value);
    return find(value) || find({series: value.series, body: 'sedan'});
  }
  /* "BA–BF Ute" -> "BA–BF Falcon ute" */
  function altFor(v) { return v ? v.label.replace(/\s+(sedan|ute|wagon)$/i, '') + ' Falcon ' + v.body : ''; }
  function readSaved() {
    try {
      var stored = JSON.parse(localStorage.getItem(storageKey));
      var value = resolve(stored);
      /* Rewrite a saved combination that no longer exists as the sedan it fell back to. */
      if (value && stored && typeof stored === 'object' && stored.body !== value.body) localStorage.setItem(storageKey, JSON.stringify({series: value.series, body: value.body}));
      return value;
    } catch (e) { return null; }
  }
  var saved = readSaved();
  function readBrowse() {
    try { return resolve(JSON.parse(sessionStorage.getItem(browseKey))); } catch (e) { return null; }
  }
  var browse = readBrowse();
  function effective() { return browse || saved; }
  var collection = document.querySelector('[data-collection-handle]');
  var handle = collection && collection.dataset.collectionHandle;
  var pageSeries = seriesOfHandle(handle);
  function seriesOfHandle(h) { return h === 'ba-bf-falcon' ? 'ba-bf' : h === 'fg-fgx-falcon' ? 'fg' : h === 'au-falcon' ? 'au' : h === 'ea-el-falcon' ? 'ea-ed' : h === 'ea-au-falcon' ? 'ea-ed' : null; }
  /* r9: the address's vehicle parameters: the query, plus series/body from a "#series=…" fragment when the query has none. */
  function addressParams(search, hash) {
    var q = new URLSearchParams(search || '');
    var h = String(hash || '').replace(/^#/, '');
    if (!/(^|&)series=/.test(h) || q.has('series')) return q;
    var f = new URLSearchParams(h);
    q.set('series', f.get('series'));
    if (f.has('body') && !q.has('body')) q.set('body', f.get('body'));
    return q;
  }
  function query() { return addressParams(window.location.search, window.location.hash); }
  var selectedSeries, selectedBody, browsing;
  /* What the page shows when it loads or the address changes. */
  function fromAddress() {
    var q = query();
    var named = q.has('series') ? normalizeSeries(q.get('series')) : null;
    if (named && !pageSeries && !vehicles.some(function (v) { return v.series === named; })) named = null;
    var eff = effective();
    function onHub(v) { return !!v && (!pageSeries || v.url.endsWith('/' + handle)); }
    selectedSeries = named ? named : (onHub(eff) ? eff.series : pageSeries && onHub(saved) ? saved.series : pageSeries) || 'ea-ed';
    /* An explicit body= wins; otherwise the browse (else the saved) vehicle's body style for this series, else sedan. */
    var linkBody = q.has('body') ? String(q.get('body')).toLowerCase() : '';
    var same = browse && browse.series === selectedSeries ? browse : saved && saved.series === selectedSeries ? saved : null;
    selectedBody = linkBody || (same ? same.body : 'sedan');
    browsing = resolve({series: selectedSeries, body: selectedBody}) || resolve({series: pageSeries || 'ea-ed', body: 'sedan'});
    if (browsing) { selectedSeries = browsing.series; selectedBody = browsing.body; }
    /* A Falcon hub (e.g. from a Shop by car chip), or an address that names a series the finder knows, sets the
       browse vehicle (never the saved one). */
    if (browsing && (pageSeries || (named && vehicles.some(function (v) { return v.series === named; })))) keepBrowse(browsing);
  }
  /* Store the browse vehicle for this visit (sessionStorage). Returns true when it changed. */
  function keepBrowse(value) {
    var next = value ? resolve(value) : null;
    try { if (next) sessionStorage.setItem(browseKey, JSON.stringify({series: next.series, body: next.body})); else sessionStorage.removeItem(browseKey); } catch (e) { /* storage blocked: the choice lasts until the next page */ }
    var changed = (browse ? browse.key : '') !== (next ? next.key : '');
    browse = next;
    return changed;
  }
  fromAddress();
  /* The page or its link names a vehicle (a Falcon hub, or ?series=). */
  function inContext() {
    if (pageSeries) return true;
    /* Only a series the finder knows: the arms page's own ?series= filter also takes values such as xe-xf. */
    var named = normalizeSeries(query().get('series'));
    return !!named && vehicles.some(function (v) { return v.series === named; });
  }
  function getActive() { return inContext() ? browsing : effective(); }
  function isMine(v) { return !!v && !!saved && saved.key === v.key; }
  function detail() { var active = getActive(); return {saved: saved, browse: browse, browsing: browsing, active: active, mine: isMine(active)}; }
  function emit(name) {
    var d = detail();
    document.dispatchEvent(new CustomEvent(name, {detail: d}));
    var all = {reason: name}; for (var k in d) all[k] = d[k];
    document.dispatchEvent(new CustomEvent('falcx:vehicle', {detail: all}));
  }
  function persist(value) {
    try { if (value) localStorage.setItem(storageKey, JSON.stringify({series: value.series, body: value.body})); else localStorage.removeItem(storageKey); return true; } catch (e) { return false; }
  }
  function setBrowsing(value) {
    var next = resolve(value);
    if (!next) return false;
    browsing = next; selectedSeries = next.series; selectedBody = next.body;
    render(); emit('falcx:browsing-change'); return true;
  }
  /* The explicit save ("Make this my Falcon"): the only writer of falcx-my-vehicle-v1. The browse vehicle is dropped,
     because the saved one is now the one on show. */
  function save(value) {
    var next = resolve(value); if (!next) return false;
    if (!persist(next)) { status('Your browser could not remember this vehicle. You can still browse its parts.'); return false; }
    var changed = !saved || saved.key !== next.key;
    saved = next; keepBrowse(null);
    if (!inContext()) { browsing = next; selectedSeries = next.series; selectedBody = next.body; }
    render(); emit('falcx:vehicle-change');
    status(changed ? 'Saved. Showing parts for your ' + next.label + '.' : 'Your ' + next.label + ' is saved.');
    return true;
  }
  /* Save whatever is on show (the vehicle line's "Make this my Falcon"). */
  function saveActive() { return save(getActive()); }
  /* A browsing choice: show it for this visit, do not save it. */
  function browseTo(value) {
    var next = resolve(value); if (!next) return false;
    if (keepBrowse(next)) { render(); emit('falcx:browsing-change'); }
    return true;
  }
  /* An explicit choice (body style button): show it and keep it as the browse vehicle. */
  function choose(value) {
    if (!setBrowsing(value)) return false;
    browseTo(browsing);
    return true;
  }
  /* "Forget": clears the saved and the browse vehicle. */
  function clear() {
    keepBrowse(null);
    if (!persist(null)) { status('Your browser could not remove the vehicle.'); render(); emit('falcx:vehicle-change'); return false; }
    saved = null; render(); emit('falcx:vehicle-change'); status('Your Falcon has been forgotten.'); return true;
  }
  /* One polite announcement: in the open dialog if there is one, else the header's live region. */
  function status(message) {
    var el = document.querySelector('[data-vehicle-dialog][open] [data-vehicle-status]') || document.querySelector('[data-vehicle-status]');
    if (el) el.textContent = message;
  }
  function destination(v, raw) {
    var url = new URL(raw || v.url, window.location.origin);
    url.searchParams.set('series', v.series); url.searchParams.set('body', v.body);
    /* r9: the vehicle now sits in the query, so a "#series=" fragment from the link is dropped (other anchors stay). */
    var hash = /(^#|&)series=/.test(url.hash) ? '' : url.hash;
    return url.pathname + url.search + hash;
  }
  function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  /* False during the first paint: the page is laid out for the vehicle already (falcx-head), so nothing is moving yet. */
  var settled = false;
  function render() {
    var active = getActive();
    var mine = isMine(active);
    /* The vehicle line under the Shop by car bar comes and goes with the vehicle. Measure it, so a choice made further
       down the page (the hero's body buttons on a phone) does not push the controls out from under the thumb. */
    var chipRow = settled ? document.querySelector('.falcx-vbar__chip') : null;
    var chipRowHeight = chipRow ? chipRow.offsetHeight : 0;
    /* Listings reserve their one-line fitment note only while a vehicle is on show (falcx-vehicle.css). */
    document.documentElement.classList.toggle('fx-vehicle', !!active);
    document.querySelectorAll('[data-vehicle-controls]').forEach(function (box) {
      var select = box.querySelector('select[name="series"]');
      if (select) select.value = selectedSeries;
      /* Body styles the series does not have are not rendered at all (no crossed-out buttons). */
      box.querySelectorAll('[data-body]').forEach(function (pill) {
        var valid = find({series: selectedSeries, body: pill.dataset.body});
        pill.hidden = !valid; pill.disabled = false; pill.setAttribute('aria-pressed', String(!!browsing && pill.dataset.body === browsing.body));
      });
      box.querySelectorAll('[data-note]').forEach(function (note) {
        note.hidden = !browsing || note.dataset.note !== browsing.body;
        if (!note.hidden && note.dataset.note === 'sedan') {
          var text = note.querySelector('span');
          if (text) text.textContent = ['ea-ed', 'ef-el', 'au'].indexOf(browsing.series) !== -1 ? 'Front coilover pairs are listed for this series. Check the product fitment before ordering.' : 'Check the product configuration and fitment for your sedan before ordering.';
        }
      });
      var go = box.querySelector('[data-go]');
      if (go) {
        go.setAttribute('aria-disabled', String(!browsing));
        if (browsing) go.href = destination(browsing); else go.removeAttribute('href');
        var label = go.querySelector('[data-go-label]');
        if (label) label.textContent = browsing ? 'Show parts for my ' + browsing.label : 'Choose a supported body style';
      }
    });
    document.querySelectorAll('[data-vehicle-series-title]').forEach(function (el) { if (browsing) el.textContent = browsing.label; });
    document.querySelectorAll('[data-vehicle-browsing]').forEach(function (el) { setText(el, browsing ? 'Showing: ' + browsing.label : 'This series and body combination is not supported. Choose a supported body style.'); });
    document.querySelectorAll('[data-my-vehicle]').forEach(function (el) { el.hidden = !saved; });
    document.querySelectorAll('[data-vehicle-saved]').forEach(function (el) { setText(el, saved ? saved.label : ''); });
    /* The compact line: "Showing parts for your BA–BF Ute · Change". */
    document.querySelectorAll('[data-vehicle-chip]').forEach(function (chip) {
      chip.hidden = false;
      chip.dataset.state = active ? (mine ? 'mine' : 'showing') : 'none';
      setText(chip.querySelector('[data-vchip-lead]'), active ? 'Showing parts for ' + (mine ? 'your ' : '') : '');
      setText(chip.querySelector('[data-vchip-name]'), active ? active.label : '');
      var change = chip.querySelector('[data-vehicle-change]');
      setText(change, active ? 'Change' : 'Choose your Falcon');
      if (change) change.setAttribute('aria-label', active ? 'Change vehicle, now ' + active.label : 'Choose your Falcon');
      var keep = chip.querySelector('[data-vehicle-keep]');
      if (keep) {
        keep.hidden = !active || mine;
        setText(keep, 'Make this my Falcon');
        if (active) keep.setAttribute('aria-label', 'Make the ' + active.label + ' my Falcon');
      }
      var forget = chip.querySelector('[data-vehicle-forget]');
      if (forget) {
        forget.hidden = !mine;
        if (mine) forget.setAttribute('aria-label', 'Forget my ' + active.label);
      }
    });
    document.querySelectorAll('[data-vehicle-clear]').forEach(function (button) { button.hidden = !saved && !browse; });
    if (chipRow) {
      var grew = chipRow.offsetHeight - chipRowHeight;
      /* Only while the line is on screen or below: when it is above the screen the browser keeps the view steady itself. */
      if (grew && chipRow.getBoundingClientRect().bottom > 0 && window.scrollBy) window.scrollBy({top: grew, left: 0, behavior: 'instant'});
    }
    document.querySelectorAll('[data-vehicle-image]').forEach(function (img) {
      /* Keep any server-rendered image as the fallback when the selected body style has no cutout. */
      if (img.dataset.fallbackSrc === undefined) { img.dataset.fallbackSrc = img.getAttribute('src') || ''; img.dataset.fallbackSrcset = img.getAttribute('srcset') || ''; img.dataset.fallbackAlt = img.getAttribute('alt') || ''; }
      if (browsing && browsing.image) {
        swapImage(img, browsing.image, altFor(browsing));
      } else if (!browsing && img.dataset.fallbackSrc) {
        img.hidden = false; img.src = img.dataset.fallbackSrc; if (img.dataset.fallbackSrcset) img.setAttribute('srcset', img.dataset.fallbackSrcset); img.alt = img.dataset.fallbackAlt;
      } else {
        img.hidden = true;
      }
    });
    /* Product links carry the vehicle on show only when it is not the remembered one (the next page knows that one). */
    var carry = active && !mine ? active : null;
    document.querySelectorAll('[data-falcx-fitment="card"]').forEach(function (card) {
      if (!card.matches('a')) return;
      var href = card.getAttribute('href');
      if (!href) return;
      if (!card.dataset.vehicleBaseUrl) card.dataset.vehicleBaseUrl = href;
      if (!card.dataset.vehicleBaseUrl) return;
      var next = carry ? destination(carry, card.dataset.vehicleBaseUrl) : card.dataset.vehicleBaseUrl;
      if (href !== next) card.setAttribute('href', next);
    });
    if (collection) {
      document.querySelectorAll('[data-body-label]').forEach(function (el) { setText(el, browsing ? browsing.body : 'selected vehicle'); });
    }
    /* Chassis pages: hide cards whose body:* tags exclude the browsed body style, or whose series:* tags exclude the
       browsed series (replacement arms). Cards without those tags (the coilovers) always show. */
    if (pageSeries) {
      document.querySelectorAll('[data-falcx-fitment="card"][data-bodies], [data-falcx-fitment="card"][data-series]').forEach(function (card) {
        var bodies = card.dataset.bodies ? card.dataset.bodies.split(',') : null;
        var series = card.dataset.series ? card.dataset.series.split(',') : null;
        var hide = !!browsing && ((bodies && bodies.indexOf(browsing.body) === -1) || (series && series.indexOf(browsing.series) === -1));
        card.hidden = hide; card.style.display = hide ? 'none' : '';
      });
      /* A row whose every card is hidden for this series shows its "nothing for this series" note instead. */
      document.querySelectorAll('[data-row-empty]').forEach(function (note) {
        var row = note.closest('.falcx-crow');
        var cards = row ? row.querySelectorAll('[data-falcx-fitment="card"]') : [];
        var shown = Array.prototype.some.call(cards, function (card) { return !card.hidden; });
        note.hidden = !cards.length || shown;
      });
    }
    /* "[series]" in a row heading and its "All …" link follow the browsed series. */
    var seriesName = browsing ? browsing.label.replace(/\s+(sedan|ute|wagon)$/i, '') : '';
    document.querySelectorAll('[data-series-label]').forEach(function (el) { setText(el, seriesName || 'Falcon'); });
    document.querySelectorAll('a[data-series-link]').forEach(function (link) {
      if (!link.dataset.seriesBase) link.dataset.seriesBase = link.getAttribute('href') || '';
      if (!link.dataset.seriesBase) return;
      var url = new URL(link.dataset.seriesBase, window.location.origin);
      if (browsing) url.searchParams.set('series', browsing.series); else url.searchParams.delete('series');
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
    syncTabs();
  }
  /* Swap a vehicle image only once the new file is decoded, so the frame never flashes empty. The first image is
     set straight away (nothing is showing yet). */
  function swapImage(img, src, alt) {
    img.dataset.want = src;
    var current = img.getAttribute('src');
    if (current === src) { img.alt = alt; img.hidden = false; return; }
    function apply() { if (img.dataset.want !== src) return; img.removeAttribute('srcset'); img.src = src; img.alt = alt; img.hidden = false; }
    if (!current || img.hidden) { apply(); return; }
    var pre = new Image(); pre.src = src;
    var done = false; function go() { if (!done) { done = true; apply(); } }
    if (pre.decode) pre.decode().then(go, go); else { pre.onload = go; pre.onerror = go; }
    setTimeout(go, 2500);
  }
  /* Tabs that stand for a Falcon hub (data-tab-collection) open on the active vehicle's hub until a tab is picked by hand. */
  var tabSets = [];
  function syncTabs() {
    var active = getActive();
    if (!active) return;
    tabSets.forEach(function (set) {
      if (set.touched) return;
      var i = set.tabs.findIndex(function (tab) { return tab.dataset.tabCollection && active.url.endsWith('/' + tab.dataset.tabCollection); });
      /* No tab for that hub (e.g. one "EA–EL / AU" tab on the AU collection): the tab whose label names the generation. */
      if (i === -1) {
        var name = active.series === 'ea-ed' || active.series === 'ef-el' ? 'EA–EL' : active.series === 'fg' || active.series === 'fgx' ? 'FG' : active.label.replace(/\s+(sedan|ute|wagon)$/i, '');
        i = set.tabs.findIndex(function (tab) { return (tab.textContent || '').indexOf(name) !== -1; });
      }
      if (i !== -1 && set.tabs[i].getAttribute('aria-selected') !== 'true') set.activate(i, false);
    });
  }
  /* The one "Change vehicle" dialog (sections/falcx-shop-by-car.liquid). */
  function dialog() { return document.querySelector('[data-vehicle-dialog]'); }
  function openDialog() {
    var d = dialog();
    if (!d) return false;
    if (d.open) return true;
    render();
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    var first = d.querySelector('select[name="series"]');
    if (first) first.focus();
    return true;
  }
  function closeDialog() {
    var d = dialog();
    if (!d || !d.open) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }
  /* A hub page shows one series: after choosing another one in the dialog, go to that Falcon's hub. */
  function afterDialog() {
    if (pageSeries && browsing && !browsing.url.endsWith('/' + handle)) { window.location.assign(destination(browsing)); return; }
    if (pageSeries && browsing && query().get('body') !== browsing.body) history.replaceState(null, '', destination(browsing, window.location.href));
    /* Opened from the phone menu, which has closed since: put focus on the vehicle line instead of the page body. */
    setTimeout(function () {
      if (document.activeElement && document.activeElement !== document.body) return;
      var change = document.querySelector('.falcx-vchip--bar [data-vehicle-change]');
      if (change && change.offsetParent) change.focus({preventScroll: true});
    }, 0);
  }
  function onClick(e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var d = dialog();
    if (d && t === d) { closeDialog(); return; }
    var el = t.closest('[data-vehicle-change], [data-vehicle-remove], [data-vehicle-clear], [data-vehicle-forget], [data-vehicle-keep], [data-vehicle-save], [data-vehicle-done], [data-vehicle-close], [data-series-btn], [data-pick], [data-go]');
    if (!el) return;
    if (el.hasAttribute('data-vehicle-change')) {
      if (openDialog()) { e.preventDefault(); return; }
      var select = document.querySelector('[data-vehicle-controls] select[name="series"]');
      if (select && select.offsetParent) { e.preventDefault(); select.focus(); select.scrollIntoView({block: 'center'}); }
      else if (!el.matches('a[href]')) window.location.assign('/#falcx-finder');
    }
    else if (el.hasAttribute('data-vehicle-remove') || el.hasAttribute('data-vehicle-clear') || el.hasAttribute('data-vehicle-forget')) {
      var focusAfter = el.closest('[data-vehicle-chip]');
      clear();
      if (el.closest('[data-vehicle-dialog]')) closeDialog();
      /* The button just pressed is now hidden: keep focus on the line. */
      else if (focusAfter) { var ch = focusAfter.querySelector('[data-vehicle-change]'); if (ch && ch.offsetParent) ch.focus({preventScroll: true}); }
    }
    /* "Make this my Falcon": the one explicit save. */
    else if (el.hasAttribute('data-vehicle-keep') || el.hasAttribute('data-vehicle-save')) {
      var line = el.closest('[data-vehicle-chip]');
      saveActive();
      if (line) { var c = line.querySelector('[data-vehicle-change]'); if (c && c.offsetParent) c.focus({preventScroll: true}); }
    }
    else if (el.hasAttribute('data-vehicle-done')) { if (browsing) browseTo(browsing); closeDialog(); }
    else if (el.hasAttribute('data-vehicle-close')) closeDialog();
    /* The hero's series buttons set the Series dropdown themselves (falcx-hero3.js); the tap is the choice (browse only). */
    else if (el.hasAttribute('data-series-btn')) { if (browsing && browsing.series === el.dataset.seriesBtn) browseTo(browsing); }
    else if (el.hasAttribute('data-pick')) picked(el);
    /* "Show parts for my BA–BF Ute": browse it on the way (the address carries it too). */
    else if (el.hasAttribute('data-go')) { if (browsing && el.closest('[data-vehicle-controls]')) browseTo(browsing); }
  }
  /* The hero's "Choose your Falcon" buttons (falcx-hero3.js moves the Series dropdown itself): picking one by hand is
     a browsing choice. Rotation never comes through here. */
  function picked(button) {
    var list = (button.dataset.series || '').split(',').map(function (x) { return x.trim(); });
    if (browsing && list.indexOf(browsing.series) !== -1) browseTo(browsing);
  }
  function onKey(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-pick]') : null;
    if (!t || [' ', 'Spacebar', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
    /* After the hero has handled the key (arrow keys move focus to the picked button). */
    setTimeout(function () { var on = document.activeElement && document.activeElement.closest ? document.activeElement.closest('[data-pick]') : null; if (on) picked(on); }, 0);
  }
  function init() {
    collection = document.querySelector('[data-collection-handle]');
    handle = collection && collection.dataset.collectionHandle;
    document.querySelectorAll('[data-vehicle-controls]').forEach(function (box) {
      if (box.dataset.vehicleReady) return;
      box.dataset.vehicleReady = 'true';
      var select = box.querySelector('select[name="series"]');
      if (select) select.addEventListener('change', function (e) {
        selectedSeries = select.value;
        browsing = resolve({series: selectedSeries, body: selectedBody});
        if (browsing) selectedBody = browsing.body;
        render(); emit('falcx:browsing-change');
        /* Picked by hand (not set by the hero script): browse it for this visit (not saved). */
        if (browsing && e && e.isTrusted) browseTo(browsing);
        if (browsing && box.hasAttribute('data-falcx-bodyfilter')) window.location.assign(destination(browsing));
      });
      box.querySelectorAll('[data-body]').forEach(function (pill) { pill.addEventListener('click', function () {
        if (!choose({series: selectedSeries, body: pill.dataset.body})) return;
        if (box.hasAttribute('data-falcx-bodyfilter')) {
          if (!browsing.url.endsWith('/' + handle)) window.location.assign(destination(browsing));
          else history.replaceState(null, '', destination(browsing, window.location.href));
        }
      }); });
      var go = box.querySelector('[data-go]');
      if (go) go.addEventListener('click', function (e) { if (!browsing) e.preventDefault(); });
    });
    document.querySelectorAll('[data-vehicle-dialog]').forEach(function (d) {
      if (d.dataset.vehicleReady) return; d.dataset.vehicleReady = 'true';
      d.addEventListener('close', afterDialog);
    });
    document.querySelectorAll('[data-falcx-tabs]').forEach(function (root) {
      if (root.dataset.vehicleReady) return; root.dataset.vehicleReady = 'true';
      var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      var panels = root.querySelectorAll('[role="tabpanel"]');
      var set = {tabs: tabs, touched: false, activate: activate};
      function activate(i, focus) {
        tabs.forEach(function (tab, j) { tab.setAttribute('aria-selected', String(i === j)); tab.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (panel, j) { panel.hidden = i !== j; });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { set.touched = true; activate(i, false); });
        tab.addEventListener('keydown', function (e) {
          var next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
          if (next !== null) { e.preventDefault(); set.touched = true; activate(next, true); }
        });
      });
      if (tabs.length) activate(Math.max(0, tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; })), false);
      tabSets.push(set);
    });
    render();
  }
  window.FalcxVehicle = {storageKey: storageKey, browseKey: browseKey, addressParams: addressParams, vehicles: vehicles, getSaved: function () { return saved; }, getBrowse: function () { return browse; }, getEffective: effective, getBrowsing: function () { return browsing; }, getActive: getActive, isMine: isMine, save: save, saveActive: saveActive, browseTo: browseTo, forget: clear, choose: choose, clear: clear, setBrowsing: setBrowsing, init: init, render: render, find: find, resolve: resolve, altFor: altFor, destination: destination, openDialog: openDialog, closeDialog: closeDialog};
  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKey);
  document.addEventListener('shopify:section:load', init);
  if (typeof MutationObserver !== 'undefined' && document.body) {
    new MutationObserver(function (records) {
      var added = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-falcx-fitment="card"], [data-vehicle-chip], [data-vehicle-controls]') || node.querySelector('[data-falcx-fitment="card"], [data-vehicle-chip], [data-vehicle-controls]'));
        });
      });
      /* Horizon re-renders the header after load: bind and paint whatever arrived. */
      if (added) init();
    }).observe(document.body, {childList: true, subtree: true});
  }

  /* Saved in another tab: the browse vehicle of this tab still wins for this visit. */
  window.addEventListener('storage', function (e) { if (e.key === storageKey || e.key === null) { saved = readSaved(); if (!browse && !inContext() && saved) { browsing = saved; selectedSeries = saved.series; selectedBody = saved.body; } render(); emit('falcx:vehicle-change'); } });
  window.addEventListener('popstate', function () { fromAddress(); render(); emit('falcx:browsing-change'); });
  /* r9: a "#series=" link to the page already open changes only the fragment (no load): show that series too. */
  window.addEventListener('hashchange', function () { if (!/(^#|&)series=/.test(String(window.location.hash || ''))) return; fromAddress(); render(); emit('falcx:browsing-change'); });
  /* Back/forward cache: the page comes back as it was left, but the vehicle may have changed on another page. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var before = (saved ? saved.key : '') + '|' + (browse ? browse.key : '');
    saved = readSaved(); browse = readBrowse();
    if ((saved ? saved.key : '') + '|' + (browse ? browse.key : '') === before) return;
    fromAddress(); render(); emit('falcx:vehicle-change');
  });
  init(); emit('falcx:vehicle-change');
  settled = true;
  if (pageSeries && browsing && !browsing.url.endsWith('/' + handle)) window.location.replace(destination(browsing));
  /* The address does not say what is on show (a body style the series does not have): correct the address bar too. */
  else if (pageSeries && browsing && query().has('body') && (query().get('body') !== browsing.body || normalizeSeries(query().get('series') || browsing.series) !== browsing.series)) history.replaceState(null, '', destination(browsing, window.location.href));
})();
